@if (tenantScope.isTenantScope()) {
  <app-tenant-band />
}

<header class="shell-header">
  <app-marketplace-header />
</header>

<main id="main-content" tabindex="-1">
  <ng-content />
</main>

<app-marketplace-footer />
